import { render, staticRenderFns } from "./AccumulationsMenu.vue?vue&type=template&id=554c20b6&scoped=true"
import script from "./AccumulationsMenu.vue?vue&type=script&lang=ts"
export * from "./AccumulationsMenu.vue?vue&type=script&lang=ts"
import style0 from "./AccumulationsMenu.vue?vue&type=style&index=0&id=554c20b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554c20b6",
  null
  
)

export default component.exports